import { useState, useEffect, useCallback } from "react";
import {
  createCancellationToken,
  debounce,
} from "../../../../services/helpers";
import api from "../../../../services/api";

export default (projectId, onSelectZone) => {
  const [zoneSearchTerm, setZoneSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [paginationToken, setPaginationToken] = useState();
  const [loadingZones, setLoadingSearchResults] = useState(false);
  const [selectedZone, setSelectedZone] = useState(null);
  const [, setCancellationToken] = useState();

  const getSearchResults = useCallback(
    debounce(async (projectId, searchTerm) => {
      if (!projectId) {
        return;
      }
      setSearchResults([]);
      setPaginationToken(undefined);
      setLoadingSearchResults(true);
      try {
        const newCancellationToken = createCancellationToken();
        setCancellationToken((oldCancellationToken) => {
          if (oldCancellationToken) {
            oldCancellationToken.cancel();
          }
          return newCancellationToken;
        });
        const accessToken = localStorage.getItem("accessToken");
        const searchZonesResponse = await api.getZones(projectId, accessToken, {
          searchTerm,
        });
        if (!newCancellationToken.shouldCancel) {
          const nextPageToken =
            searchZonesResponse.headers["x-bluedot-paginationtoken"];
          if (nextPageToken) {
            setPaginationToken(nextPageToken);
          }
          setSearchResults(searchZonesResponse.data);
          setLoadingSearchResults(false);
        }
      } catch (error) {
        const errorMessage =
          "Something went wrong while trying to retrieve project zones";
        console.log(error);
        alert(errorMessage);
        setLoadingSearchResults(false);
      }
    }),
    [setCancellationToken, projectId]
  );

  const getNextPageOfZones = useCallback(
    async (projectId) => {
      setLoadingSearchResults(true);
      try {
        const newCancellationToken = createCancellationToken();
        setCancellationToken((oldCancellationToken) => {
          if (oldCancellationToken) {
            oldCancellationToken.cancel();
          }
          return newCancellationToken;
        });
        const accessToken = localStorage.getItem("accessToken");
        const searchZonesResponse = await api.getZones(projectId, accessToken, {
          paginationToken,
        });
        if (!newCancellationToken.shouldCancel) {
          const nextPageToken =
            searchZonesResponse.headers["x-bluedot-paginationtoken"];
          setPaginationToken(nextPageToken);
          setSearchResults([...searchResults, ...searchZonesResponse.data]);
          setLoadingSearchResults(false);
        }
      } catch (error) {
        const errorMessage =
          "Something went wrong while trying to retrieve project zones";
        console.log(error);
        alert(errorMessage);
        setLoadingSearchResults(false);
      }
    },
    [
      searchResults,
      paginationToken,
      setPaginationToken,
      setLoadingSearchResults,
      setCancellationToken,
      projectId,
    ]
  );

  const onUpdateSearchTerm = (event) => {
    setZoneSearchTerm(event.target.value);
  };

  useEffect(() => {
    getSearchResults(projectId, zoneSearchTerm);
  }, [zoneSearchTerm, projectId, getSearchResults]);

  useEffect(() => {
    if (selectedZone) {
      setSelectedZone(null);
      onSelectZone(null);
    }
  }, [projectId]);

  return {
    loadingZones,
    zones: searchResults,
    textValue: zoneSearchTerm,
    onTextChange: onUpdateSearchTerm,
    onSelectOption: setSelectedZone,
    hasMorePages: Boolean(paginationToken),
    requestNextPage: () => getNextPageOfZones(projectId),
    selectedZone,
  };
};
